module.exports = __webpack_public_path__ + "img/icon03.861923ff.png";